import {
  ActivityListApiElementContentModel,
  ActivityListApiPropertiesModel,
} from '@/services/platform/api/model';
import { cn, ModuleProperties } from '@/lib/core';
import ModuleWrapper from '@/components/shared/module/wrapper';
import { ProfileActivityList } from '@/components/shared/profile/activity/list';

export const ActivityListAPI = (props: ModuleProperties) => {
  const content = props.content as ActivityListApiElementContentModel | undefined;
  const appSettings = props.context?.settings;
  if (!content) return null;

  const properties = content.properties as ActivityListApiPropertiesModel;
  const shopPath = properties?.shopBtn?.route?.path ?? '/';
  const detailPath = appSettings?.properties?.activityDetail?.route?.path;

  return (
    <ModuleWrapper
      component={props}
      classNames={{
        base: cn(['module__activity-list']),
        container: cn(['flex-1']),
        wrapper: cn(['py-0', 'flex-1']),
        grid: cn(['flex flex-col flex-1 gap-0']),
      }}
      isFullWidth={true}
      {...props}
    >
      <ProfileActivityList properties={properties} shopPath={shopPath} detailPath={detailPath} />
    </ModuleWrapper>
  );
};
